var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"d-flex align-center justify-center h-full"},[_c('div',[_c('h1',{staticClass:"primary--text"},[_vm._v(_vm._s(_vm.$t('PurchaseRequestSuccess')))]),_c('h4',{staticClass:"secondary--text"},[_vm._v(_vm._s(_vm.$t('CloseStoreWindow')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }